const W = 270;
const H = 560;

export const PhoneMockup = ({ src, label, scale = 1, testId, className = "", eager = false, glow = true }) => (
  <div data-testid={testId} className={`relative shrink-0 ${className}`} style={{ width: W * scale, height: H * scale }}>
    {glow && (
      <div aria-hidden="true" className="absolute inset-x-[8%] bottom-[-6%] top-[20%] rounded-full bg-pa-orange/30 blur-[60px]" />
    )}
    <div
      className="absolute left-0 top-0 origin-top-left rounded-phone bg-[#0b0b0b] p-[8px] shadow-phone ring-1 ring-white/10"
      style={{ width: W, height: H, transform: scale === 1 ? undefined : `scale(${scale})` }}
    >
      <div className="relative h-full w-full overflow-hidden rounded-[37px] bg-[#0c0c0c]">
        <img
          src={src}
          alt={label}
          width="923"
          height="2000"
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : undefined}
          decoding="async"
          className="h-full w-full object-cover object-top"
        />
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[37px] ring-1 ring-inset ring-white/[0.06]" />
      </div>
    </div>
  </div>
);
